import type { ComponentProps, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import type { TYPOGRAPHY_VARIANTS } from '../../../config/typography/constants';
import { Typography } from '../typography/Typography';

export type FormattedMessageTypographyProps = ComponentProps<typeof FormattedMessage> & {
  /** Typographies map from tags inside the given message. */
  typographies?: Record<string, TYPOGRAPHY_VARIANTS>;
  /** FormattedMessage usual values, without the typographies tags. */
  values?: Record<string, any>;
};

export const FormattedMessageTypographyBase = ({
  typographies = undefined,
  values = undefined,
  ...props
}: FormattedMessageTypographyProps) => {
  const typographyValues = typographies
    ? Object.keys(typographies).reduce(
        (acc, tagName) => ({
          ...acc,
          [tagName]: (chunks) => <Typography variant={typographies[tagName]}>{chunks}</Typography>,
        }),
        {} as { [key: string]: (chunks: ReactNode[]) => ReactNode },
      )
    : null;

  return (
    <FormattedMessage
      {...props}
      values={
        typographyValues || values
          ? {
              ...typographyValues,
              ...values,
            }
          : null
      }
    />
  );
};

FormattedMessageTypographyBase.displayName = 'FormattedMessage';

// Not using memo here because we never useMemo the values prop so it would just be useless.
export const FormattedMessageTypography = FormattedMessageTypographyBase;
